// @ts-ignore file not converted to TS yet
import Cookie from 'js-cookie';
import { LOGIN_EMAIL_COOKIE_NAME, LOGIN_METADATA_COOKIE_NAME } from '../constants/cookies';
import { getDomain } from './urls';
export const setLoginMetadataCookieEnableAll = () => {
  Cookie.set(LOGIN_METADATA_COOKIE_NAME, JSON.stringify({
    isMobileLogin: true
  }), {
    domain: getDomain()
  });
};
export const getParsedLoginMetadataCookie = () => {
  const loginMetadataCookie = Cookie.get(LOGIN_METADATA_COOKIE_NAME);
  return JSON.parse(loginMetadataCookie.replace(/\\"/g, '"'));
};
const LOGIN_EMAIL_COOKIE_TTL_MINUTES = 5;
export const setLoginEmailCookie = email => {
  const expires = new Date(Date.now() + LOGIN_EMAIL_COOKIE_TTL_MINUTES * 60 * 1000);
  Cookie.set(LOGIN_EMAIL_COOKIE_NAME, email, {
    domain: getDomain(),
    expires
  });
};
export const getLoginEmailCookie = () => {
  return Cookie.get(LOGIN_EMAIL_COOKIE_NAME);
};
export const clearLoginEmailCookie = () => {
  Cookie.remove(LOGIN_EMAIL_COOKIE_NAME, {
    domain: getDomain()
  });
};